<template>
  <div class="location-wrap">
    <div class="location">
      <div class="location__info">
        <div class="location__name">
          {{ location.name }}
        </div>
        <div class="location__wait">
          <span
            v-if="waitDataUnavailable"
            class="error"
          >
            Wait times temporarily unavailable.
          </span>
          <template v-else>
            <span class="low">
              {{ waitLow }}
            </span>
            –
            <span class="high">
              {{ waitHigh }} {{ minuteSuffix(waitHigh) }}
            </span>
          </template>
        </div>
      </div>
      <div class="location__actions">
        <a
          :href="reserveUrl"
          data-ga-on="click"
          data-ga-event-category="Reserve"
          data-ga-event-action="click"
          :data-ga-event-label="location.name"
        >
          <img
            src="./../assets/button_reserve.svg"
            alt="Reserve My Spot"
          >
        </a>
        <a
          v-if="mapUrl"
          :href="mapUrl"
          data-ga-on="click"
          data-ga-event-category="Map"
          data-ga-event-action="click"
          :data-ga-event-label="location.name"
        >
          <img
            src="./../assets/button_map.svg"
            alt="Get Map"
          >
        </a>
      </div>
    </div>
    <div
      v-if="location.notes"
      class="location__notes"
      v-html="notesHtml"
    />
  </div>
</template>

<script>
import nl2br from '../nl2br';

export default {
  name: 'WaitTimeLocation',
  props: {
    location: {
      type: Object,
      required: true,
    },
    waitData: {
      type: Object,
      required: true,
    },
    waitDataUnavailable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isDevEnvironment() {
      return this.$store.getters.isDevEnvironment;
    },
    waitLow() {
      return this.waitData ? Math.ceil(parseInt(this.waitData.start, 10) / 60) : 0;
    },
    waitHigh() {
      return this.waitData ? Math.ceil(parseInt(this.waitData.end, 10) / 60) : 0;
    },
    mapUrl() {
      return this.location ? this.location.map_url : null;
    },
    ser() {
      return this.location ? this.location.ser : null;
    },
    visitType() {
      return 11704205;
    },
    reserveUrl() {
      if (this.isDevEnvironment) {
        return this.location ? this.location.reserveUrlDev : null;
      }
      return this.location ? this.location.reserveUrl : null;
    },
    iframeUrl() {
      if (this.isDevEnvironment) {
        // eslint-disable-next-line
        return `https://epmycht-un1-np4.unch.unc.edu/MyChart-SUP/SignupAndSchedule/EmbeddedSchedule?id=${this.ser}&vt=${this.visitType}&dept=${this.location.location_id}&view=grouped`;
      }

      // eslint-disable-next-line
      return `https://myuncchart.org/mychart/SignupAndSchedule/EmbeddedSchedule?id=${this.ser}&vt=${this.visitType}&dept=${this.location.location_id}&view=grouped`;
    },
    notesHtml() {
      return nl2br(this.location.notes);
    },
  },
  methods: {
    minuteSuffix(int) {
      return int === 1 ? 'min' : 'mins';
    },
    openReserve() {
      this.$emit('reserve', this.iframeUrl);
    },
  },
};
</script>

<style lang="scss">
.location-wrap {
  background: #ededed;
  border-bottom: 1px solid #ddd;
  padding: 1.25rem .75rem;
  text-align: center;
  @media (min-width: 768px) {
    padding: 1.25rem;
  }
}

.location-wrap:last-child {
  border-bottom: none;
}

.location {
  align-items: center;
  display: flex;
  margin: 0 auto;

  &__info {
    flex-basis: 100%;
    flex-shrink: 1;
    margin-right: 1rem;
  }

  &__actions {
    flex-shrink: 0;
    white-space: nowrap;

    a, button {
      align-items: center;
      background: #e1e1e1;
      border: none;
      border-radius: 20rem;
      color: #444;
      cursor: pointer;
      display: inline-flex;
      flex-direction: column;
      font-size: 10px;
      justify-content: center;
      text-align: center;
      text-decoration: none;
      width: 50px;
      height: 50px;
      @media (min-width: 768px) {
        width: 75px;
        height: 75px;
      }

      &:hover {
        box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14),
        0 1px 10px 0 rgba(0, 0, 0, 0.12),
        0 2px 4px -1px rgba(0, 0, 0, 0.3);
        color: #fff;
      }

      img {
        height: 100%;
        width: 100%;
      }
    }
  }
}

.location__name {
  color: #666;
  font-size: .9rem;
  font-weight: 600;
  line-height: 1.2;
  text-align: left;
  text-transform: capitalize;
  @media (min-width: 768px) {
    font-size: 1.2rem;
  }
}

.location__wait {
  color: #444;
  font-size: 1.4rem;
  font-weight: bold;
  letter-spacing: -1px;
  text-align: left;
  white-space: nowrap;
  @media (min-height: 540px) and (min-width: 450px) {
    font-size: 1.8rem;
  }
  @media (min-height: 670px) and (min-width: 450px) {
    font-size: 2.8rem;
  }

  .error {
    color: #ff0000;
    font-size: 1rem;
    font-weight: normal;
    letter-spacing: normal;
  }
}

.location__notes {
  background: #ffffcc;
  border-radius: 8px;
  padding: 6px 8px;
  text-align: left;
}
</style>
